
(() => {
  const instances = new WeakMap();

  function findNav(el, sel) {
    // First look inside the container, then one level up (common markup),
    // otherwise return null to avoid wiring the wrong buttons.
    return el.querySelector(sel) || el.parentElement?.querySelector(sel) || null;
  }

  function buildOptions(el) {
    const isFancy = el.classList.contains('fancy');

    // Base options shared by both
    const opts = {
      loop: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      centeredSlides: isFancy,                 // fancy = centered
      slidesPerView: isFancy ? 1 : 'auto',     // numbers for fancy, 'auto' for basic
      spaceBetween: isFancy ? 0 : 20,
      autoplay: false,
      on: {}
      // NOTE: do NOT set init:false unless you plan to call instance.init() yourself.
    };

    // Scope navigation to this slider only (if present)
    const nextEl = findNav(el, '.swiper-button-next');
    const prevEl = findNav(el, '.swiper-button-prev');
    if (nextEl && prevEl) {
      opts.navigation = { nextEl, prevEl };
    }

    if (isFancy) {
      opts.effect = 'coverflow';
      opts.coverflowEffect = {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 0,
        scale: 0,
        slideShadows: false
      };
      opts.breakpoints = {
        680:  { slidesPerView: 3 },
        1020: { slidesPerView: 5 }
      };
      opts.on.init = function () {
        // force reflow to avoid first-frame glitches
        void this.el.offsetWidth;
        if (typeof setUniformSlideHeights === 'function') setUniformSlideHeights();
      };
      opts.on.slideChange = function () {
        if (typeof updateSlideAngles === 'function') {
          requestAnimationFrame(() => updateSlideAngles(this));
        }
      };
    } else {
      opts.on.init = function () {
        if (typeof setUniformSlideHeights === 'function') setUniformSlideHeights();
      };
    }

    return opts;
  }

  function mount(el) {
    if (instances.has(el)) return instances.get(el);
    if (typeof window.Swiper !== 'function') {
      console.error('Swiper is not loaded before init script.');
      return null;
    }
    const instance = new Swiper(el, buildOptions(el));
    instances.set(el, instance);
    return instance;
  }

  function initAll(root = document) {
    root.querySelectorAll('.swiper').forEach(mount);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
})();


function setUniformSlideHeights() {

	const slides = document.querySelectorAll('.swiper-slide');
	let maxHeight = 0;
  
	slides.forEach(slide => {
	  slide.style.height = 'auto'; // reset first in case of resize
	  const height = slide.offsetHeight;
	  if (height > maxHeight) {
		maxHeight = height;
	  }
	});
  
	slides.forEach(slide => {
		slide.style.height = `${maxHeight}px`;
		slide.classList.add('height-set');
	});
	
  }
  

function updateSlideAngles(swiperInstance) {
	const slides = swiperInstance.slides;
	const activeIndex = swiperInstance.activeIndex;
	// void swiperInstance.el.offsetWidth;
  
	slides.forEach((slide, index) => {
		slide.classList.remove('no-transition', 'angled-left', 'angled-right');
		
		if (!slide.classList.contains('swiper-slide-visible')) {
			return;
		}
		
		if (index > activeIndex) {
			slide.classList.add('angled-right');
		} else if (index < activeIndex) {
			slide.classList.add('angled-left');
		}

		const angledRights = Array.from(slides).filter(s => s.classList.contains('angled-right'));
		if (angledRights.length) {
			angledRights[angledRights.length - 1].classList.add('no-transition');
		}

		const angledLefts = Array.from(slides).filter(s => s.classList.contains('angled-left'));
		if (angledLefts.length) {
			angledLefts[0].classList.add('no-transition');
		}
	});
  }
  
  window.addEventListener('load', () => {
	const hiddenSlide = document.querySelector('.swiper-slide');

	if (hiddenSlide) {
		hiddenSlide.style.transition = 'transform 0.001s';
		hiddenSlide.style.transform = 'scale(1.0001)';

		requestAnimationFrame(() => {
			hiddenSlide.style.transform = 'scale(1)';
		});
	}
});